import dcrDetailsPopupComponent from './dcrDetailsPopup.component.js';

const dcrDetailsPopupModule = angular.module('app.components.dataManagement.dcrDetailsPopup', [])
	.component('dcrDetailsPopup', dcrDetailsPopupComponent)
	.name;

export default dcrDetailsPopupModule;
